import {
  Box,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import { styled } from "@mui/styles";

const StyledTableContainer = styled(TableContainer)(({ theme }) => ({
  marginTop: "10px",
  borderRadius: "8px",
  boxShadow: "none",
  overflowY: "auto",
  "&::-webkit-scrollbar": {
    width: "4px", // ความกว้างของ scrollbar
  },
  "&::-webkit-scrollbar-track": {
    background: "#F5F5F5", // สีเทาอ่อนมากสำหรับพื้นหลัง
    borderRadius: "8px", // มุมโค้งมน
  },
  "&::-webkit-scrollbar-thumb": {
    background: "#CCCCCC", // สีเทากลางสำหรับ scrollbar
    borderRadius: "8px", // มุมโค้งมน
  },
  "&::-webkit-scrollbar-thumb:hover": {
    background: "#999999", // สีเทาเข้มเมื่อ hover
  },
}));

const StyledTableHead = styled(TableHead)(({ theme }) => ({
  background: "linear-gradient(90deg, #00BB9F 0%, #6CD8BF 100%)",
  position: "sticky",
  top: 0, // ตำแหน่ง sticky
  zIndex: 1, // เพื่อให้แสดงอยู่ด้านบน TableBody
}));

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  borderBottom: "none",
  color: "#FFFFFF",
  width: (props) => props.width || "auto", // Use width prop or default to auto
}));

const BodyTableCell = styled(TableCell)(({ theme, idx }) => ({
  backgroundColor: idx % 2 === 0 ? theme.palette.common.white : "#F8F7FD",
  paddingLeft: "16px",
  paddingRight: "16px",
  width: (props) => props.width || "auto", // Use width prop or default to auto
}));

const BodyTableCell2 = styled(TableCell)(({ theme, idx }) => ({
  backgroundColor: idx % 2 === 0 ? theme.palette.common.white : "#F1F0FA     ",
  paddingLeft: "16px",
  paddingRight: "16px",
  width: (props) => props.width || "auto", // Use width prop or default to auto
}));

const TableReport = ({ loading, data, columns, lastRow }) => {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        height: "calc(100vh - 300px)",
        overflow: "hidden",
      }}
    >
      <StyledTableContainer component={Paper}>
        <Table>
          <StyledTableHead>
            <TableRow>
              {columns.map((column, index) => (
                <StyledTableCell
                  key={index}
                  align={column.align || "left"}
                  width={column.width || "auto"}
                >
                  {column.label}
                </StyledTableCell>
              ))}
            </TableRow>
          </StyledTableHead>
          <TableBody>
            {!loading && data?.length > 0
              ? data.map((row, rowIndex) => (
                  <TableRow key={rowIndex} hover>
                    {columns.map((column, colIndex) => (
                      <BodyTableCell
                        key={colIndex}
                        align={column.align || "left"}
                        width={column.width || "auto"}
                        idx={rowIndex}
                      >
                        {column.render
                          ? column.render(row, rowIndex)
                          : row[column.field]}
                      </BodyTableCell>
                    ))}
                  </TableRow>
                ))
              : !loading && (
                  <TableRow>
                    <BodyTableCell
                      colSpan={columns.length}
                      align="center"
                      sx={{ padding: "20px" }}
                      idx={0}
                    >
                      ไม่มีข้อมูล
                    </BodyTableCell>
                  </TableRow>
                )}
            {!loading && lastRow && (
              <TableRow
                sx={{
                  backgroundColor: "#D3E4DD",
                  fontWeight: "bold",
                  position: "sticky",
                  bottom: 0,
                }}
              >
                {columns.map((column, colIndex) => (
                  <BodyTableCell2
                    key={colIndex}
                    align={column.align || "left"}
                    width={column.width || "auto"}
                    idx={data?.length || 1}
                    sx={{ fontWeight: "bold" }}
                  >
                    {lastRow[column.field] || ""}
                  </BodyTableCell2>
                ))}
              </TableRow>
            )}
          </TableBody>
        </Table>
      </StyledTableContainer>
    </Box>
  );
};

export default TableReport;
